var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('AccountTransaction', {
    attrs: {
      "id": _vm.accountId,
      "is-show": _vm.isAccountSurplusHistoryVisible,
      "account-code": _vm.accountCode
    },
    on: {
      "update:isShow": function ($event) {
        _vm.isAccountSurplusHistoryVisible = $event;
      },
      "update:is-show": function ($event) {
        _vm.isAccountSurplusHistoryVisible = $event;
      }
    }
  }), _vm.isShow ? _c('ModalAccount', {
    attrs: {
      "accountId": _vm.accountId,
      "isShow": _vm.isShow,
      "travelAgentId": _vm.ArTravelAgentId
    },
    on: {
      "refetch": _vm.onAfterUpdateAccount,
      "update:isShow": function ($event) {
        _vm.isShow = $event;
      },
      "update:is-show": function ($event) {
        _vm.isShow = $event;
      }
    }
  }) : _vm._e(), _c('EzTable', {
    ref: "tableRef",
    attrs: {
      "actions": _vm.actions,
      "toolbarConfig": {
        disableColumnChooser: this.data.Id
      },
      "pageConfig": {
        disablePagination: this.data.Id
      },
      "data-source": _vm.arClient.api_AR_RAA01,
      "columns": _vm.columns,
      "data-source-params": {
        ArTravelAgentId: _vm.ArTravelAgentId
      }
    },
    on: {
      "action-1": function (data) {
        _vm.isShow = true;
        _vm.accountId = data.data.Id;
      },
      "action-2": function (data) {
        _vm.isAccountSurplusHistoryVisible = true;
        _vm.accountId = data.data.Id;
        _vm.accountCode = data.data.AccountCode;
      }
    },
    scopedSlots: _vm._u([{
      key: "beforeToolbarActions",
      fn: function () {
        return [_vm._t("beforeToolbarButton")];
      },
      proxy: true
    }, {
      key: "toolbar",
      fn: function () {
        return [_c('div', [_vm._t("button"), _c('PermissionButton', {
          staticStyle: {
            "margin-left": "6px"
          },
          attrs: {
            "api-code": _vm.AR_IAA01,
            "variant": "outline-primary"
          },
          on: {
            "click": function () {
              _vm.isShow = true;
              _vm.accountId = null;
            }
          }
        }, [_c('ez-icon', {
          attrs: {
            "icon": "ezAr-icon-plus-circle"
          }
        }), _vm._v(" " + _vm._s(_vm.$t("ar_common_add_new")) + " ")], 1)], 2)];
      },
      proxy: true
    }], null, true)
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }